/* ══ SVG pro laser (xTool Creative Space) ═══════════════════════════════
   Z návrhu gravírování udělá SVG v měřítku 1:1 v mm:
   – modrý obrys čepele jako vodítko (ve skupině „obrys-cepele-nevypalovat“),
   – nápis převedený na křivky (XCS text v SVG neumí), případně logo.
   Počátek souřadnic (0, 0) = pata čepele u hřbetu, stejně jako v návrháři.
   Písma se čtou knihovnou fontkit (umí i woff2) ze stejných souborů, jaké
   používá e-shop, takže tvar i rozměr odpovídají náhledu (ověřeno 29. 9. 2026,
   odchylka do 0,05 mm). Když se cokoli nepovede, vrátí null a objednávka
   jde bez SVG (údaje o umístění zůstanou v „_Gravírování — data“). */
(function () {
  'use strict';
  var FONTKIT = 'https://cdn.jsdelivr.net/npm/fontkit@2.0.4/+esm';
  var CORMORANT = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@1,500&display=swap';
  var fk = null, fkLoading = null, cache = {}, loading = {};

  function lib() {
    if (fk) return Promise.resolve(fk);
    if (!fkLoading) /* import() přes Function, aby ho minifikace assetů Shopify nepřepsala na require(). */
    fkLoading = (new Function('u', 'return import(u)'))(FONTKIT).then(function (m) { fk = m.create ? m : m.default; return fk; });
    return fkLoading;
  }
  /* URL souborů písma z @font-face na stránce. Vrací všechny soubory dané rodiny
     v řezu 400 normal (Marcellus má zvlášť latin a latin-ext kvůli háčkům). */
  function faceUrls(fam) {
    var sheets = document.styleSheets, out = [];
    for (var i = 0; i < sheets.length; i++) {
      var rules; try { rules = sheets[i].cssRules; } catch (e) { continue; }
      if (!rules) continue;
      for (var j = 0; j < rules.length; j++) {
        var r = rules[j];
        if (r.type !== 5) continue;
        if (r.style.fontFamily.replace(/["']/g, '').trim() !== fam) continue;
        if ((r.style.fontStyle || 'normal') !== 'normal') continue;
        if (!/(^|\s)400(\s|$)/.test(r.style.fontWeight || '400')) continue;
        var src = r.style.getPropertyValue('src') || '';
        var m = src.match(/url\(["']?([^"')]+\.woff2)["']?\)/) || src.match(/url\(["']?([^"')]+)["']?\)/);
        if (m) { var u = new URL(m[1], sheets[i].href || location.href).href; if (out.indexOf(u) < 0) out.push(u); }
      }
    }
    return out;
  }
  /* Rodina, kterou náhled opravdu sází: první položka tokenu --hc-font-serif /
     --hc-font-sans (od 24. 10. 2026 Marcellus a Inter), pak dřívější písma.
     Do 3. 11. 2026 se hledalo napevno Novela a Lato. Po přechodu webu na Inter
     zůstalo Lato jen v řezu 500, Moderní a Verzálky pak SVG nevytvořily vůbec
     a objednávka odešla bez souboru; Klasické šlo Novelou, i když náhled ukazoval
     Marcellus. */
  function familyUrls(token, fallback) {
    var fams = [];
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue(token) || '';
      var first = v.split(',')[0].replace(/["']/g, '').trim();
      if (first) fams.push(first);
    } catch (e) {}
    fallback.forEach(function (f) { if (fams.indexOf(f) < 0) fams.push(f); });
    for (var i = 0; i < fams.length; i++) {
      var u = faceUrls(fams[i]);
      if (u.length) return u;
    }
    return [];
  }
  function fetchFont(u) {
    return fetch(u).then(function (r) { if (!r.ok) throw new Error('font ' + r.status); return r.arrayBuffer(); })
      .then(function (b) { return fk.create(new Uint8Array(b)); });
  }
  /* Písma podle pořadí radií: 0 Klasické (patkové písmo webu), 1 Moderní a 3 Verzálky
     (bezpatkové písmo webu), 2 Psané (Cormorant Garamond kurzíva). */
  function load(i) {
    if (cache[i]) return Promise.resolve(cache[i]);
    if (loading[i]) return loading[i];
    loading[i] = lib().then(function () {
      if (i === 2) {
        return fetch(CORMORANT).then(function (r) { return r.text(); }).then(function (css) {
          var urls = [], re = /url\(([^)]+)\)/g, m;
          while ((m = re.exec(css))) urls.push(m[1].replace(/["']/g, ''));
          return Promise.all(urls.map(fetchFont));
        });
      }
      var urls = i === 0 ? familyUrls('--hc-font-serif', ['Marcellus', 'Novela'])
                         : familyUrls('--hc-font-sans', ['Inter', 'Lato']);
      if (!urls.length) throw new Error('font url');
      return Promise.all(urls.map(fetchFont));
    }).then(function (fonts) { cache[i] = fonts; return fonts; });
    loading[i].catch(function () { loading[i] = null; });
    return loading[i];
  }
  function ready(i) { return !!cache[i]; }
  function pick(fonts, cp) {
    for (var i = 0; i < fonts.length; i++) if (fonts[i].hasGlyphForCodePoint(cp)) return fonts[i];
    return fonts[0];
  }
  function n(v) { return (Math.round(v * 1000) / 1000).toString(); }

  /* Nápis jako křivky: střed (x, y) jako SVG text-anchor=middle + dominant-baseline=central,
     fs = velikost písma v mm, ls = prostrkání (násobek fs) za každým znakem. */
  function textPath(fonts, t, fs, ls, x, y) {
    var runs = [];
    Array.from(t).forEach(function (ch) {
      var f = pick(fonts, ch.codePointAt(0)), last = runs[runs.length - 1];
      if (last && last.f === f) last.t += ch; else runs.push({ f: f, t: ch });
    });
    var total = 0, placed = [];
    runs.forEach(function (r) {
      var s = fs / r.f.unitsPerEm, lay = r.f.layout(r.t);
      lay.glyphs.forEach(function (g, k) {
        var p = lay.positions[k];
        placed.push({ g: g, s: s, dx: total + p.xOffset * s, dy: p.yOffset * s });
        total += p.xAdvance * s + ls * fs;
      });
    });
    var f0 = fonts[0], s0 = fs / f0.unitsPerEm;
    var x0 = x - total / 2, base = y + (f0.ascent + f0.descent) / 2 * s0;
    var d = [];
    placed.forEach(function (q) {
      var ox = x0 + q.dx, oy = base - q.dy;
      var T = function (a, b) { return n(ox + a * q.s) + ' ' + n(oy - b * q.s); };
      q.g.path.commands.forEach(function (c) {
        var a = c.args;
        if (c.command === 'moveTo') d.push('M' + T(a[0], a[1]));
        else if (c.command === 'lineTo') d.push('L' + T(a[0], a[1]));
        else if (c.command === 'quadraticCurveTo') d.push('Q' + T(a[0], a[1]) + ' ' + T(a[2], a[3]));
        else if (c.command === 'bezierCurveTo') d.push('C' + T(a[0], a[1]) + ' ' + T(a[2], a[3]) + ' ' + T(a[4], a[5]));
        else if (c.command === 'closePath') d.push('Z');
      });
    });
    return d.join('');
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* o = { K, text: { t, fi, fs, ls, x, y } | null, logo: { x, y, w, h, href } | null } → SVG (string) nebo null. */
  function svg(o) {
    var K = o.K, parts = [];
    if (o.text) {
      if (!ready(o.text.fi)) return null;
      parts.push('<path d="' + textPath(cache[o.text.fi], o.text.t, o.text.fs, o.text.ls, o.text.x, o.text.y) + '"/>');
    }
    if (o.logo && o.logo.href) {
      parts.push('<image x="' + n(o.logo.x) + '" y="' + n(o.logo.y) + '" width="' + n(o.logo.w) + '" height="' + n(o.logo.h) +
        '" preserveAspectRatio="xMidYMid meet" href="' + o.logo.href + '" xlink:href="' + o.logo.href + '"/>');
    }
    if (!parts.length) return null;
    var pad = 3, x0 = -pad, y0 = -pad, w = K.L + 2 * pad, h = K.H + 2 * pad;
    var popis = o.popis ? esc(o.popis) : '';
    return '<?xml version="1.0" encoding="UTF-8"?>\n' +
      '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + n(w) + 'mm" height="' + n(h) + 'mm" viewBox="' +
      [x0, y0, w, h].map(n).join(' ') + '">\n' +
      '<title>HobbyChef – gravírování – ' + esc(K.nuz || '') + '</title>\n' +
      '<desc>Měřítko 1:1, jednotky mm. Počátek (0,0) je pata čepele u hřbetu. Modrý obrys čepele je jen vodítko pro zarovnání – nevypalovat. ' + popis + '</desc>\n' +
      '<g id="obrys-cepele-nevypalovat" fill="none" stroke="#0066FF" stroke-width="0.1"><path d="' + esc(K.blade) + '"/></g>\n' +
      '<g id="gravirovani" fill="#000000" stroke="none">' + parts.join('') + '</g>\n' +
      '</svg>\n';
  }

  window.HCLaser = { load: load, ready: ready, svg: svg };
})();
